/* eslint-disable default-param-last */
import { SET_CURRENT_PRODUCT } from "../actions/types";
const initState = {
    attribute_toggles: [],
    flavors: [],
    how_to_use: [],
    image: "",
    ingredient_string: "",
    mixes_well_with: [],
    name: "",
    nutrition_facts: "",
    product_info: [],
    product_title: "",
    reason_why: "",
    icons: [],
    ingredients: [],
    short_name: "",
    when_to_take: [],
};
export default function currentProductReducer(state = initState, action) {
    switch (action.type) {
        case SET_CURRENT_PRODUCT: {
            return action.payload;
        }
        default:
            return state;
    }
}
